<template>
  <mdb-container class="gp-has-header">
    <div v-if="!showResponse">
      <data-table v-if="filters" ref="responses"
                  :click-handler="openResponse"
                  :columns="columns"
                  :dropdown-values="filters"
                  data-source="/customForm/responses"
                  dropdown-filter
                  filterLabel="Filter on Form"
                  page-title="Form Response"
      />
    </div>
    <div v-if="showResponse" class="text-left">
      <mdb-btn size="sm" rounded @click="showResponse = false" icon="arrow-left">Back to List</mdb-btn>
      <form-response :responseId="selectedId" v-if="selectedId"/>
    </div>

  </mdb-container>
</template>

<script>

import dataTable from '../common/DataTable'
import {mdbBtn, mdbContainer} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import FormResponse from "./FormResponse";

export default {
  name: 'form-responses',
  components: {
    mdbContainer,
    mdbBtn,
    dataTable,
    FormResponse
  },
  data() {
    return {
      columns: [
        {label: "Form", field: "formName"},
        {label: "User", field: "user"},
        {label: "Submitted", field: "submitted"}
      ],
      filters: [

      ],
      showResponse: false,
      selectedId: null
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true)
    api.get("/customForm/list?max=200&offset=0").then(
      (results) => {
        for (let row of results.data.rows) {
          this.filters.push( { text: row.name, value: row.id})
        }

      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 5000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    openResponse(r) {
      this.selectedId = r.id
      this.showResponse = true
    }

  }

}
;
</script>
